<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
<template>
<transition name="fade">
	<div v-show="show" class="fixed pin z-50 h-content">
		<div class="min-w-64 h-content max-w-sm bg-teal-lightest rounded border-t-4 border-teal-dark bor px-6 py-4 shadow-lg m-6 absolute pin-r" role="alert">
			<div class="flex">
				<div class="py-1">
					<svg class="fill-current h-6 w-6 text-teal mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg>
				</div>
				<div class="text-grey-darkest">
					<p class="font-thin text-xl" v-text="header"></p>
					<p class="font-thin text-sm" v-text="content"></p>
				</div>
			</div>
		</div>
	</div>
</transition>
</template>
<script>

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			header: '',
			content: '',
		}
	},

	mounted() {
		bus.$on('show-notification', this.showNotification)
	},

    beforeDestroy() {
		bus.$off('show-notification')
    },

	methods: {
		showNotification(header, content, timeout = 5000) {
			this.show = true

			this.header = header
			this.content = content

			setTimeout(() => {
				this.show = false
			}, timeout);
		},
	}
}
</script>